import React, { Component } from 'react';

import { MDBRow } from 'mdbreact';
import ImageGallery from 'react-image-gallery';

import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';

class Real12 extends Component {

  render() {
    
    const images = [
      {
        original: require("../../assets/images/porte/porte1.jpg"),
        thumbnail: require("../../assets/images/porte/porte1.jpg")
      },
      {
        original: require("../../assets/images/porte/porte2.jpg"),
        thumbnail: require("../../assets/images/porte/porte2.jpg")
      },
      {
        original: require("../../assets/images/porte/porte3.jpg"),
        thumbnail: require("../../assets/images/porte/porte3.jpg")
      },
      {
        original: require("../../assets/images/porte/porte4.jpg"),
        thumbnail: require("../../assets/images/porte/porte4.jpg")
      },
      {
        original: require("../../assets/images/porte/porte5.jpg"),
        thumbnail: require("../../assets/images/porte/porte5.jpg")
      },
      {
        original: require("../../assets/images/porte/porte6.jpg"),
        thumbnail: require("../../assets/images/porte/porte6.jpg")
      },
      {
        original: require("../../assets/images/porte/porte7.jpg"),
        thumbnail: require("../../assets/images/porte/porte7.jpg")
      }
    ];

    return (
      <MDBRow className="Real">
        <h1>Mise en sécurité d'un porte sectionnelle</h1>
        <ImageGallery
          items={images}
          showIndex={true}
          showPlayButton={false}
          showThumbnails={false}
          showFullscreenButton={false}
        />
      </MDBRow>
    )
  }
}

export default Real12;